<div class="container-fluid">
    <div class="row">   
        <div class="col-12 col-md-3">
            <div class="card">
                <div class="card-body">
                    <h3 class="fs-4 fw-bold">Banker Group Detail</h3>
                    <hr/>
                    <p><strong>Name:</strong> {{data.name}}</p>
                    <p><strong>Status:</strong> {{data.status ? 'Active' : 'Disabled'}}</p>
                    <p><strong>Created At:</strong> {{data.timestamp | date:'dd/MM/yyyy'}}</p>
                    <p><strong>Banker Balance:</strong> {{data.wallet | number: '1.2-2'}}</p>
                    <div class="btn-group w-100">
                        <button class="btn btn-primary btn-sm" (click)="bankerTopup()">Topup</button>
                        <button class="btn btn-primary btn-sm" (click)="bankerWithdraw()">Withdraw</button>
                        <button class="btn btn-primary btn-sm" (click)="statement()">Statement</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-9">
            <div class="d-flex flex-row justify-content-between mb-2 align-items-center">
                <h3 class="mb-0 fw-bolder">Banker Admin List</h3>
                <button class="btn btn-primary btn-sm" (click)="addAdmin()">Add Admin</button>
            </div>
            <table class="table table-bordered table-striped table-sm">
                <thead class="table-primary">
                    <tr>
                        <th>Code</th>
                        <th>Name</th>
                        <th>Mobile/Username</th>
                        <th>Status</th>
                        <th>Edit</th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let admin of admins">
                        <td class="align-middle">{{admin.code}} {{admin.is_banker_super_admin == 1 ? ' (Super Admin)' : ''}}</td>
                        <td class="align-middle">{{admin.name}}</td>
                        <td class="align-middle">{{admin.mobile}}</td>
                        <td class="align-middle">{{admin.status ? 'Active' : 'Disabled'}}</td>
                        <td>
                            <button class="btn btn-primary btn-sm" (click)="editAdmin(admin)">Edit</button>
                        </td>
                        <td>
                            <button class="btn btn-danger btn-sm" (click)="deleteAdmin(admin)">Delete</button>
                        </td>
                    </tr>
                    <tr *ngIf="admins.length == 0"><td colspan="6" class="text-center">No data found</td></tr>
                </tbody>
            </table>

            <h3 class="mb-0 fw-bolder">Banker List</h3>
            <table class="table table-bordered table-striped table-sm">
                <thead class="table-primary">
                    <tr>
                        <th>Code</th>
                        <th>Name</th>
                        <th>Mobile/Username</th>
                        <th>Balance</th>
                        <th>No of Referral</th>
                        <th>Active Loan</th>
                        <th>Total Loan</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let banker of bankers">
                        <td class="align-middle">{{banker.code}}</td>
                        <td class="align-middle">{{banker.name}}</td>
                        <td class="align-middle">{{banker.mobile}}</td>
                        <td class="align-middle">{{banker.balance}}</td>
                        <td class="align-middle"><a href="javascript:void(0)" (click)="viewReferral(banker)">{{banker.no_of_referral}}</a></td>
                        <td class="align-middle"><a href="javascript:void(0)" (click)="viewActiveLoan(banker)">{{banker.no_of_active_loan}}</a></td>
                        <td class="align-middle"><a href="javascript:void(0)" (click)="viewLoan(banker)">{{banker.no_of_loan}}</a></td>
                        <td class="align-middle">{{banker.status ? 'Active' : 'Disabled'}}</td>
                        <td>
                            <button class="btn btn-primary btn-sm" (click)="editAdmin(banker)">Edit</button>
                        </td>
                    </tr>
                    <tr *ngIf="bankers.length == 0"><td colspan="10" class="text-center">No data found</td></tr>
                </tbody>
            </table>

        </div>
    </div>
</div>